import { useState, useEffect } from 'react';
import useSocket from '../../../shared/hooks/useSocket';

export default function useChat(roomId, username) {
  const { socket, connected } = useSocket();
  const [messages, setMessages] = useState([]);
  const [joined, setJoined] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const handleMessage = (msg) => {
      setMessages((prev) => [...prev, msg]);
    };

    const handleRoomUsers = (usersList) => {
      setUsers(usersList);
    };

    socket.on('message', handleMessage);
    socket.on('room-users', handleRoomUsers);

    return () => {
      socket.off('message', handleMessage);
      socket.off('room-users', handleRoomUsers);
    };
  }, [socket]);

  // Declaratively join/re-join the room when connected and joined are true
  useEffect(() => {
    if (connected && joined && username && roomId) {
      socket.emit('join-room', { roomId, name: username });
    }
  }, [connected, joined, username, roomId, socket]);

  const joinRoom = (name) => {
    if (!name?.trim() || !roomId) return;
    setJoined(true);
  };

  const leaveRoom = (name) => {
    if (!name || !roomId) return;
    socket.emit('leave-room', { roomId, name });
    setJoined(false);
    setMessages([]);
    setUsers([]);
  };

  const sendMessage = (name, text) => {
    if (!text?.trim() || !name || !roomId) return;
    socket.emit('send-message', { roomId, name, text });
  };

  return {
    messages,
    joined,
    setJoined,
    joinRoom,
    leaveRoom,
    sendMessage,
    connected,
    users,
  };
}
